var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useMemo } from "react";
import { observer } from "mobx-react-lite";
import JoditEditor, { Jodit } from "jodit-react";
import { fontsWithSizes, buttons, useStringifiedDependency, } from "./utils";
import { useFormContext } from "../Form";
import { classNames } from "../utils/classNames";
var BASIC_THEME_NAME = "piston";
var BASIC_CLASS_NAME = "jodit-wrapper";
export var WYSIWYGEditor = observer(function (_a) {
    var html = _a.html, onChange = _a.onChange, onBlur = _a.onBlur, onInit = _a.onInit, className = _a.className, name = _a.name, _b = _a.customControls, customControls = _b === void 0 ? [] : _b, _c = _a.fonts, fonts = _c === void 0 ? {} : _c, _d = _a.sizes, sizes = _d === void 0 ? {} : _d, _e = _a.width, width = _e === void 0 ? "auto" : _e, _f = _a.height, height = _f === void 0 ? 250 : _f, _g = _a.allowTabNavigation, allowTabNavigation = _g === void 0 ? true : _g, _h = _a.disabled, disabled = _h === void 0 ? false : _h, _j = _a.useNativeTooltip, useNativeTooltip = _j === void 0 ? false : _j, _k = _a.toolbarAdaptive, toolbarAdaptive = _k === void 0 ? false : _k, _l = _a.showPlaceholder, showPlaceholder = _l === void 0 ? true : _l;
    var values = useFormContext().values;
    var customControlsStringified = useStringifiedDependency(customControls);
    var handleEvent = useCallback(function (handler, newValue) {
        if (typeof handler !== "function")
            return;
        handler(newValue);
        if (name) {
            values.set(name, newValue);
        }
    }, []);
    var menuControls = useMemo(function () {
        return customControls.reduce(function (o, control) {
            var _a;
            return (__assign(__assign({}, o), (_a = {}, _a[control.name] = {
                name: control.label,
                tooltip: control.tooltip,
                exec: control.onClick,
                isDisabled: function () {
                    return control.disabled === undefined ? false : control.disabled;
                },
            }, _a)));
        }, {});
    }, [customControlsStringified]);
    var config = useMemo(function () { return (__assign(__assign({}, Jodit.defaultOptions), { controls: __assign(__assign({}, fontsWithSizes(fonts, sizes)), menuControls), events: {
            afterInit: function (instance) {
                if (typeof onInit === "function") {
                    onInit(instance);
                }
            },
        }, extraButtons: Object.keys(menuControls), theme: BASIC_THEME_NAME, disablePlugins: "powered-by-jodit", buttons: buttons, disabled: disabled, width: width, height: height, allowTabNavigation: allowTabNavigation, toolbarAdaptive: toolbarAdaptive, useNativeTooltip: useNativeTooltip, showPlaceholder: showPlaceholder })); }, [
        menuControls,
        disabled,
        width,
        height,
        allowTabNavigation,
        toolbarAdaptive,
        useNativeTooltip,
    ]);
    return (React.createElement(JoditEditor, { value: html, config: config, className: classNames(BASIC_CLASS_NAME, className), onChange: function (newValue) { return handleEvent(onChange, newValue); }, onBlur: function (newValue) { return handleEvent(onBlur, newValue); } }));
});
